import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Location from "../../../../Utility/Crud/Location";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminLocationList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
      const rows = Location.sort(Object.values(this.context.locationsIndexed));

      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            { key: "name", name: "Name", type: "string" },
            {
              key: "regionId",
              name: "Sales Region",
              type: "region",
              filter: true,
            },
            {
              key: "fieldOperationsRegionId",
              name: "Field Operations Region",
              type: "region",
              filter: true,
            },
            { key: "npi", name: "NPI", type: "number" },
          ]}
          rows={rows}
          onClick={(location) => {
            this.props.history.push({
              pathname: "/admin/location/" + location.id,
            });
          }}
        />
      );
    }
  },
);
